import { configureStore } from '@reduxjs/toolkit';
import { GLOBAL } from 'data/constants';
// Services
import { freeTrialApi } from 'services/freeTrial';
import { loginApi } from 'services/login';
import { masterDataApi } from 'services/masterDataApi';

export const initializeStore = (rootReducer) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .concat(freeTrialApi.middleware)
        .concat(loginApi.middleware)
        .concat(masterDataApi.middleware),
    devTools: GLOBAL.isDevelopment, // process.env.NODE_ENV === 'development',
  });
};
